import sessionStorageUtils from "@/utils/session-storage";
const getUiErrorByCode = (errCode) => {
  const uiBackendErr = sessionStorageUtils.getItem('errorMsg');
  if(!uiBackendErr){
    return ''
  }
  return uiBackendErr[errCode] || ''
};

export default { getUiErrorByCode };
